import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateChecksum',
  standalone: true
})
export class TruncateChecksumPipe implements PipeTransform {
  transform(checksum: string, length: number = 16): string {
    if (!checksum) {
      return '';
    }
    return checksum.length > length ? checksum.substring(0, length) + '...' : checksum;
  }
}
